exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2CscE{position:relative;overflow:hidden;-ms-touch-action:pan-y pinch-zoom;touch-action:pan-y pinch-zoom}.v8nWF{display:-ms-flexbox;display:flex}", ""]);

// exports
exports.locals = {
	"container": "_2CscE",
	"slick-track": "v8nWF",
	"slickTrack": "v8nWF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/mobile/views/home/components/mobile-carousel/mobile-carousel.styl
// module id = 2798
// module chunks = mobile/mobile